import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from 'react-google-maps';
import markerImage from '../../../../../../assets/images/marker0-1500.gif';

class MarkerWrapper extends Component {
  constructor(props) {
    super(props);

    this.toggleInfo = this.toggleInfo.bind(this);
    this.getInfo = this.getInfo.bind(this);
  }

  getInfo() {
    if (!this.props.isActive) {
      return null;
    }

    const { lat, lng, children } = this.props;

    return (
      <InfoWindow
        position={{ lat, lng }}
      >
        <div>
          {children}
        </div>

      </InfoWindow>
    );
  }

  toggleInfo() {
    this.props.onInfoToggle(this.props.locationId, this.props.lat);
  }

  render() {
    const {
      lat, lng, colsY, rowX,
    } = this.props;

    const iconImage = {
      url: markerImage,
      size: new window.google.maps.Size(21, 22),
      origin: new window.google.maps.Point(colsY * 21, rowX * 22),
    };

    return (
      <Marker
        position={{ lat, lng }}
        onClick={this.toggleInfo}
        icon={iconImage}

      >
        {this.getInfo()}
      </Marker>
    );
  }
}

MarkerWrapper.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  children: PropTypes.node,
  isActive: PropTypes.bool,
  locationId: PropTypes.number,
  colsY: PropTypes.number,
  rowX: PropTypes.number,
  onInfoToggle: PropTypes.func,
};

MarkerWrapper.defaultProps = {
  lat: 0,
  lng: 0,
  children: null,
  isActive: false,
  locationId: 0,
  colsY: 0,
  rowX: 0,
  onInfoToggle: () => true,
};


export default MarkerWrapper;
